import React from 'react';

const ServiceCard = ({ 
  service, 
  isSelected, 
  onClick,
  showDescription = true,
  highlightColor = '#4F46E5',
  isAdmin = false
}) => {
  // Converter a cor primária para uma versão mais clara para o fundo
  const getLightColor = (hexColor) => {
    // Se for no modo admin, já temos um estilo definido
    if (isAdmin) return '';
    
    // Tentar converter a cor para uma versão com opacidade
    try {
      // Verificar se é um valor hexadecimal válido
      if (!hexColor || !hexColor.startsWith('#')) return 'rgba(79, 70, 229, 0.05)'; // Cor padrão com opacidade
      
      // Converter para RGB e adicionar opacidade
      const r = parseInt(hexColor.slice(1, 3), 16);
      const g = parseInt(hexColor.slice(3, 5), 16);
      const b = parseInt(hexColor.slice(5, 7), 16);
      
      return `rgba(${r}, ${g}, ${b}, 0.08)`;
    } catch (e) {
      console.error('Erro ao converter cor:', e);
      return 'rgba(79, 70, 229, 0.05)'; // Fallback para cor padrão
    }
  };
  
  return (
    <div 
      className={`p-3 rounded-lg mb-2 cursor-pointer transition-all ${
        isSelected 
          ? isAdmin 
            ? 'border-2 border-blue-500 bg-blue-50' 
            : 'border-2'
          : 'border border-gray-200'
      }`}
      style={{
        borderColor: isSelected && !isAdmin ? highlightColor : undefined,
        backgroundColor: isSelected && !isAdmin ? getLightColor(highlightColor) : undefined
      }}
      onClick={() => onClick(service)}
      role="button"
      tabIndex="0"
      aria-pressed={isSelected}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(service);
        }
      }}
    >
      <div className="flex justify-between">
        <div>
          <h4 className={`font-medium ${isSelected ? (isAdmin ? 'text-blue-500' : '') : ''}`}>{service.nome}</h4>
          {showDescription && service.descricao && (
            <p className="text-sm text-gray-600">{service.descricao}</p>
          )}
        </div>
        <div className="text-right">
          <p className={`font-medium ${isSelected ? (isAdmin ? 'text-blue-500' : '') : ''}`}>R$ {service.preco.toFixed(2)}</p>
          <p className="text-sm text-gray-500">{service.duracao} min</p>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard; 